import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Title } from '@lib/components/v2/Title';
import Page from '@lib/components/v2/Page';
import { localizedString } from '@languages';
import classes from './Welcome.style.module.scss';

export default function Welcome({ onStart }) {
  const buttons = [
    {
      label: parse(localizedString('welcome.flowV2ButtonText')),
      onClick: () => {
        onStart();
      },
      dataTestId: 'welcome-button'
    }
  ];

  return (
    <Page buttons={buttons}>
      <div className={classes.wrapper}>
        <Title
          className={classes.heading}
          data-testid="welcome-heading"
          title={localizedString('welcome.flowV2Title')}
        />
        <div className={classes.description} data-testid="welcome-description">
          {parse(localizedString('welcome.flowV2Description'))}
        </div>
        <div className={classes.space} />
        <div className={classes.hyperlink} data-testid="welcome-hyperlink">
          {parse(localizedString('welcome.flowV2HyperlinkText'))}
        </div>
      </div>
    </Page>
  );
}

Welcome.propTypes = {
  onStart: PropTypes.func.isRequired
};
